// extracted by mini-css-extract-plugin
module.exports = {"backButton":"components-base-Button-Icons-BackButton-BackButton__backButton--3uS4R","backButtonText":"components-base-Button-Icons-BackButton-BackButton__backButtonText--1lqfX"};